// src/routes/admin/workspace/__layout.tsx
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth, requireSurface } from '@/lib/guards';
import { AdminShell } from '@/components/layouts/AdminShell';

export const Route = createFileRoute('/_staff/admin/workspace')({
  beforeLoad: (ctx) => {
    requireAuth({ location: ctx.location });
    requireSurface('workspace');
  },
  component: WorkspaceLayout,
  staticData: { crumb: 'Workspace', surface: 'Workspace Admin' },
});

function WorkspaceLayout() {
  return (
    <AdminShell variant="workspace">
      <Outlet />
    </AdminShell>
  );
}
